export class ListData {
  canAdd!: boolean;
  pageIndex!: number;
  totalCount!: number;
  pageSize!: number;
  pageData!: {
    id: any
    kitchenName: string
    lossReason: string
    menuItemIcon: string
    menuItemName: string
    reportedOn: string
    type: string
    reportedBy: {
      reportedByIcon: string
      reportedByName: string
    }
  }[];
}

export class ListFilter {
  pageSize!: number;
  pageNumber!: number;
  restaurantId!: any;
  kitchensIds!: any[]
  lossReason!: any[]
  reportedFrom!: number
  reportedTo!: number
  userIds?: any[]
  sort!: number
  searchText!: string;
}

export class menuItemFilter {
  pageSize!: number;
  pageNumber!: number;
  restaurantId!: number
  itemName!: string
  sectionId!: number
  sectionIds!: number[]
}

export enum status {
  Active = 0,
  Inactive = 1
}

export enum lossReason {
  Burnet = 0,
  GuestIssue = 1,
  Dropped = 2,
  Damaged = 3,
  Spoiled = 4,
  Expired = 5
}

export enum Disposition {
  Donated = 0,
  Garbage = 1,
  ReturnedtoSupplier = 2,

}

export enum sortList {
  RecentlyAdded = 1,
  OldestAdded = 2,
}
